











import Component from 'vue-class-component'
import Vue from 'vue'

import Navbar from '@/components/Navbar.vue'
import MessageAlert from '@/components/MessageAlert.vue'

@Component({
  name: 'DefaultContainer',
  components: {
    Navbar,
    MessageAlert
  }
})
class DefaultContainer extends Vue {}

export default DefaultContainer
